
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { LayoutUsuarios } from "../../layouts";
import { BackdropScreen, SwitchDinamico } from "../../components";
import { useUsuarioXID } from "../../../hooks/cache";


import Swal from "sweetalert2";
import { configuracionPermisos } from "../../../services";




export const SettingsUsuario = () => {


    const { id } = useParams();
    const queryClient = useQueryClient();
    const { data } = useUsuarioXID(id); 
    const permisos = data?.permisosExtra || [];
    const [cargando, setCargando] = useState(false);
    


    const handleEditarSettings = async (valor) => {
        const pregunta = await Swal.fire({
            title: 'Modificar Permiso',
            text: '¿Está seguro de modificar este permiso?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí',
            cancelButtonText: 'Cancelar',
        });

        if (!pregunta.isConfirmed) return;

        setCargando(true);
        const resp = await configuracionPermisos({ permiso: valor, id });
        setCargando(false);

        if(resp) { await queryClient.invalidateQueries({ queryKey: ['user-id'] }) } 
    
    };


    const opciones = [
        { key: "listadosocios", titulo: "Listado Socios" },
        { key: "listaclientes", titulo: "Listado Clientes" },
        { key: "todasop", titulo: "Todas las O.P." },
        { key: "todositems", titulo: "Todos los Items" },
        { key: "ajustesslideshow", titulo: "Imagenes Slide-Show" },
        { key: "materiaprima", titulo: "Materia Prima" },
        { key: "notasingreso", titulo: "Notas Ingreso Stock" },
        { key: "unidadmedida", titulo: "Unidad de Medida" },
    ];
    



    return (
        <LayoutUsuarios titulo='Permisos de Usuario'>
            <BackdropScreen cargando={cargando} titulo="Aplicando cambios en los permisos..." />

            <>
            {opciones.map((item) => (
                <SwitchDinamico
                    key={item.key}
                    titulo={item.titulo}
                    permisoKey={item.key}
                    checked={permisos?.includes(item.key) || false}
                    marginbotom={2}
                    onChange={ handleEditarSettings }
                />
            ))}
            </>

        </LayoutUsuarios>
    )
}
